module.exports = __webpack_public_path__ + "img/team.5ab2f5a4.png";